<template>
  <section class="page-section">
    <!-- filter -->
    <div class="filter-region no-margin-top">
      <div class="filter-form">
        <el-form
          size="small"
          :inline="true"
          :model="filterForm"
          ref="filterForm"
        >
          <el-form-item label="订单号：" prop="orderNo">
            <el-input
              v-model="filterForm.orderNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户姓名：" prop="customer">
            <el-input
              v-model="filterForm.customer"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="预约项目：" prop="name">
            <el-input v-model="filterForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="下单门店：" prop="shopName">
            <el-input
              v-model="filterForm.shopName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户ID：" prop="userId">
            <el-input
              v-model="filterForm.userId"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户手机号：" prop="phone">
            <el-input
              v-model="filterForm.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="顾客所属管家：" prop="serviceUserId">
            <el-select v-model="filterForm.serviceUserId" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.serviceUserName"
                :value="item.serviceUserId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间：" prop="orderTime" class="auto-width">
            <el-date-picker
              v-model="filterForm.orderTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="time-shortcut">
            <el-button
              plain
              @click="getLastFewDays(-7)"
              :class="{ 'is-active': isActiveShortcut(-7) }"
              >近7天</el-button
            >
            <el-button
              plain
              @click="getLastFewDays(-30)"
              :class="{ 'is-active': isActiveShortcut(-30) }"
              >近30天</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="filter-btn">
        <el-button-group class="btn-group">
          <el-button
            plain
            class="btn-reset"
            icon="el-icon-refresh"
            @click="filterFormReset('filterForm')"
          ></el-button>
          <el-button
            type="primary"
            class="btn-search"
            @click="filterFormSubmit('filterForm')"
            :loading="tableLoading"
            >查询</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-tabs
      class="mt-20 no-margin-top"
      v-model="tabName"
      type="card"
      @tab-click="handleTabsChange"
    >
      <el-tab-pane label="全部" name="-1"></el-tab-pane>
      <el-tab-pane label="已预约" name="2"></el-tab-pane>
      <el-tab-pane label="已完成" name="3"></el-tab-pane>
      <el-tab-pane label="已取消" name="4"></el-tab-pane>
    </el-tabs>

    <!-- table -->
    <div class="table-region mt-10" v-loading="tableLoading">
      <!-- 自定义表格 -->
      <div class="custom-table">
        <div class="custom-table-header">
          <el-row :gutter="10">
            <el-col :span="7">
              <div class="table-cell">项目</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">价格</div>
            </el-col>
            <!-- <el-col :span="2"><div class="table-cell">会员权益</div></el-col> -->
            <el-col :span="2">
              <div class="table-cell">实付金额</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">下单时间</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">下单门店</div>
            </el-col>
            <el-col :span="3">
              <div class="table-cell">客户</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">跟进管家</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell">订单状态</div>
            </el-col>
            <el-col :span="2">
              <div class="table-cell text-align-right">操作</div>
            </el-col>
          </el-row>
        </div>
        <div class="custom-table-body">
          <div class="no-data" v-if="tableData.length == 0">暂无数据</div>
          <!-- order item -->
          <div
            class="order-list-item"
            v-for="(item, index) in tableData"
            :key="index"
            v-else
          >
            <div class="item-header">
              <el-row :gutter="10">
                <el-col :span="18">
                  <div class="table-cell">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <p class="text">订单号：{{ item.orderNo }}</p>
                      </el-col>
                      <el-col :span="8">
                        <p class="text">尘锋单号：{{ item.externalOrderNo }}</p>
                      </el-col>
                      <el-col :span="8">
                        <p class="text">
                          项目数量：{{
                            (item.serviceOrderItemVOS &&
                              item.serviceOrderItemVOS.length) ||
                            0
                          }}
                        </p>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="table-cell text-align-right">
                    <el-button
                      v-if="item.status == 2"
                      type="text"
                      size="small"
                      @click="handleDownloadPDF(item, index)"
                      >下载PDF</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="pageNavigateToOrderOrderDetail(item)"
                      >查看详情</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="item-body">
              <el-row :gutter="10">
                <el-col :span="7">
                  <div class="table-cell">
                    <div class="table-cell">
                      <div class="goods-title">
                        <div class="thumb-wrap">
                          <img
                            :src="
                              item.servicePic || require('@/assets/default.png')
                            "
                          />
                        </div>
                        <p>{{ item.serviceName }}</p>
                        <p>备注：{{ item.serviceRemark || "-" }}</p>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">
                    <p class="text">￥{{ item.price }}</p>
                    <p class="text">₩{{ item.koreaPrice }}</p>
                  </div>
                </el-col>
                <!-- <el-col :span="2"><div class="table-cell">
                                            <p class="text" v-if="item.discount">{{ item.discount }}折</p>
                                        </div></el-col> -->
                <el-col :span="2">
                  <div class="table-cell">
                    <p class="text" v-if="item.actualPayment">
                      ￥{{ item.actualPayment }}
                    </p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">
                    <p class="text">
                      {{ COMMON.formatDate("2", "-", item.orderTime) }}
                    </p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">
                    <p class="text">{{ item.shopName }}</p>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="table-cell">
                    <p class="text">{{ item.customerName }}</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">
                    <p class="text">{{ item.serviceUserName }}</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">
                    <p class="text" v-if="item.status == 2">已预约</p>
                    <p class="text" v-if="item.status == 3">已完成</p>
                    <p class="text" v-if="item.status == 4">已取消</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell text-align-right">
                    <!-- 完成预约 -->
                    <el-popover
                      placement="top"
                      width="160"
                      v-model="item.completeVisible"
                      popper-class="confirm-popover"
                      v-if="item.status == 2"
                    >
                      <p>实付金额：</p>
                      <div style="margin-top: 10px">
                        <el-input
                          v-model="item.amount"
                          class="w150"
                          maxlength="6"
                          type="number"
                          style="font-size: 12px"
                        ></el-input>
                      </div>
                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="item.completeVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleCompleteOrder(item)"
                          :loading="deleteLoading"
                          >确定</el-button
                        >
                      </div>
                      <el-button size="small" type="text" slot="reference"
                        >服务完成</el-button
                      >
                    </el-popover>
                    <br />
                    <!-- 取消 -->
                    <el-popover
                      placement="bottom"
                      width="160"
                      v-model="item.deleteVisible"
                      popper-class="confirm-popover"
                      v-if="item.status == 2"
                    >
                      <p>确定取消预约？</p>
                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="item.deleteVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleCancelOrder(item)"
                          :loading="deleteLoading"
                          >确定</el-button
                        >
                      </div>
                      <el-button size="small" type="text" slot="reference"
                        >取消预约</el-button
                      >
                    </el-popover>
                    <br />
                    <!-- 添加返佣 -->
                    <el-popover
                      placement="bottom"
                      width="160"
                      v-model="item.commissionVisible"
                      popper-class="confirm-popover"
                      v-if="item.whetherToRebate && item.status != 4"
                    >
                      <p>确定添加返佣？</p>
                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="item.commissionVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleAddCommission(item)"
                          :loading="deleteLoading"
                          >确定</el-button
                        >
                      </div>
                      <el-button size="small" type="text" slot="reference"
                        >添加返佣</el-button
                      >
                    </el-popover>
                    <!-- 删除订单 -->
                    <el-popover
                      placement="bottom"
                      width="160"
                      v-model="item.deleteOrderVisible"
                      popper-class="confirm-popover"
                      v-if="item.orderNo.includes('Na')"
                    >
                      <p>确定删除订单？</p>
                      <div>
                        <el-button
                          size="small"
                          type="default"
                          plain
                          @click="item.deleteOrderVisible = false"
                          >取消</el-button
                        >
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleDeleteOrder(item)"
                          :loading="deleteLoading"
                          >确定</el-button
                        >
                      </div>
                      <el-button size="small" type="text" slot="reference"
                        >删除订单</el-button
                      >
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-footer" v-if="page.total > 0">
      <div class="selection-operate"></div>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 50, 100]"
          :pager-count="5"
          :current-page="page.current"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import {
  COMMON,
  list,
  serviceOrdersList,
  serviceOrdersCancel,
  orderDownloadPDF,
  serviceOrdersComplete,
  addRebate,
  deleteServiceOrder,
} from "../../../common/api";

export default {
  name: "orderServiceOrderList",
  data() {
    return {
      COMMON,

      tabName: this.$route.query.tabname ? this.$route.query.tabname : "-1", // 选项卡name

      filterForm: {
        // 筛选表单值
        orderNo: "", // 订单号
        customer: "",
        name: "",
        shopName: "",
        orderTime: "",
        userId: "",
        phone: "",
        // serviceUserName: ''
        serviceUserId: "", // 服务商id
      },
      options: [], //管家
      page: {
        // 分页参数
        current: 1,
        size: 20,
        total: 0,
      },

      tableLoading: true,
      tableData: [],

      deleteLoading: false,
    };
  },
  methods: {
    // 获取管家列表
    getManagerList() {
      list()
        .then((res) => {
          if (res.data.length === 0) {
            this.$message.error("暂无管家信息");
            return;
          }
          this.options = res.data;
        })
        .catch(() => {
          this.$message.error("获取管家列表失败");
        });
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let time = this.filterForm.orderTime;
      let param = {
        orderNo: this.filterForm.orderNo,
        customer: this.filterForm.customer,
        name: this.filterForm.name,
        shopName: this.filterForm.shopName,
        startTime: time && time.length > 1 ? new Date(time[0]).getTime() : "",
        endTime:
          time && time.length > 1
            ? new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1
            : "",
        current: this.page.current,
        size: this.page.size,
        serviceUserName: this.filterForm.serviceUserName,
        serviceUserId: this.filterForm.serviceUserId,
        userId: this.filterForm.userId,
        phone: this.filterForm.phone,
      };

      if (this.tabName) {
        if (this.tabName == "0") {
          param.status = -1;
        } else {
          param.status = Number(this.tabName);
        }
      }

      serviceOrdersList(param)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.tableData = data.records || [];
            this.page.total = data.total;

            this.$nextTick(() => {
              // 这个页面是自定义表格，检查最外层滚动容器是否改变，目前由于外层结构调整，目前主要的滚动条在 .app-container 上挂载的
              const scrollContainer = document.querySelector(".app-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = 0;
              }
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.tableLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      this.page.current = 1;
      this.page.size = 20;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [filterFormReset description] 下载PDF
     * @return {[type]}          [description]
     */
    handleDownloadPDF(item, index) {
      item.downloadLoading = true;
      this.$set(this.tableData, index, item);

      var params = {
        orderId: item.id,
      };
      orderDownloadPDF(params)
        .then((res) => {
          console.log(res);
          let disposition = res.headers["content-disposition"];
          item.downloadLoading = false;
          this.$set(this.tableData, index, item);
          // if(res.code == 0){
          const blob = new Blob([res.data], { type: "application/pdf" });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = this.getFilenameFromContentDisposition(disposition);
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
            // URL.revokeObjectURL(downloadUrl);
          }, 100);
          // }else{
          //     this.$message({ message: res.msg, type: "error" });
          // }
        })
        .catch((error) => {
          console.log(error);
          item.downloadLoading = false;
          this.$set(this.tableData, index, item);
          this.$message.error("服务器异常");
        });
    },
    getFilenameFromContentDisposition(contentDisposition) {
      if (!contentDisposition) return "订单";
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches && matches[1]) {
        return decodeURIComponent(matches[1].replace(/['"]/g, ""));
      }
      return "订单";
    },
    /**
     * [pageNavigateToOrderOrderDetail description] 查看订单详情
     * @param  {[Object]} item [description] 当前操作的订单对象
     * @return {[type]}          [description]
     */
    pageNavigateToOrderOrderDetail: function (item) {
      this.$router.push({
        path: "/order/service/order/detail",
        query: { id: item.id, tabname: this.tabName },
      });
    },
    /**
     * [getLastFewDays description] 获取近几日日期
     * @param  {[Number]} day [description] 需要获取的近几日的数值
     * @return {[type]}        [description]
     */
    getLastFewDays: function (day) {
      this.filterForm.orderTime = [];
      this.filterForm.orderTime.push(COMMON.getDay(day));
      this.filterForm.orderTime.push(COMMON.getDay(0));
    },
    /**
     * 判断时间快捷选项是否处于选中状态
     */
    isActiveShortcut(day) {
      if (!this.filterForm.orderTime || this.filterForm.orderTime.length !== 2)
        return false;
      return (
        this.filterForm.orderTime[0] === COMMON.getDay(day) &&
        this.filterForm.orderTime[1] === COMMON.getDay(0)
      );
    },
    // 取消预约
    handleCancelOrder: function (row) {
      this.deleteLoading = true;
      var params = {
        orderId: row.id,
      };
      serviceOrdersCancel(params)
        .then((res) => {
          this.deleteLoading = false;
          if (res.code == 0) {
            row.deleteVisible = false;
            this.getList();
            this.$message({ message: "取消成功", type: "success" });
          } else {
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch((error) => {
          this.deleteLoading = false;
          this.$message.error("服务器异常");
        });
    },
    // 完成预约
    handleCompleteOrder: function (row) {
      if (!row.amount || isNaN(row.amount)) {
        this.$message.error("请输入实付金额");
        return false;
      }

      this.deleteLoading = true;
      var params = {
        orderId: row.id,
        amount: row.amount,
      };
      serviceOrdersComplete(params)
        .then((res) => {
          this.deleteLoading = false;
          if (res.code == 0) {
            row.completeVisible = false;
            this.getList();
            this.$message({ message: "服务完成成功", type: "success" });
          } else {
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch((error) => {
          this.deleteLoading = false;
          this.$message.error("服务器异常");
        });
    },
    // 添加返佣
    handleAddCommission(e) {
      addRebate({ id: e.id }).then((res) => {
        if (res.code == 0) {
          e.commissionVisible = false;
          this.getList();
          this.$message({ message: "添加返佣成功", type: "success" });
        } else {
          this.$message({ message: res.msg, type: "error" });
        }
      });
    },
    // 删除订单
    handleDeleteOrder(e) {
      deleteServiceOrder({
        id: e.id,
      }).then((res) => {
        if (res.code == 0) {
          e.deleteOrderVisible = false;
          this.getList();
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.getManagerList();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.goods-title {
  position: relative;
  padding-left: 58px;
  min-height: 48px;

  .thumb-wrap {
    @include position(absolute, 3, 50%, none, none, 0);
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  p {
    line-height: 1.4;

    & + p {
      margin-top: 5px;
    }
  }
}

.mr-10 {
  margin-right: 10px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-10 {
  margin-top: 10px !important;
}

.dialog-body-title {
  text-indent: 15px;
  margin-bottom: 10px;
  font-size: $baseFS;
}

.filter-region {
  flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    &.time-shortcut {
      background: initial;
      padding: 0;

      :deep(.el-form-item__content) {
        width: auto;

        .el-button {
          width: 110px;
          height: 40px;
          border-radius: 5px;

          &.is-active {
            border: 1px solid #3388ff;
            color: #3388ff;
            background-color: #ecf5ff;
          }
        }
      }
    }
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.custom-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  // margin-bottom: 50px;

  .custom-table-header {
    flex-shrink: 0;
    padding-right: 4px;
    // text-align: center;
    scrollbar-gutter: stable;
  }

  .custom-table-body {
    flex: 1;
    padding-right: 4px;
    overflow-y: overlay;
  }
}

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;
// }

// .filter-region {
//   flex-shrink: 0; // 筛选区域不压缩
//   display: flex;
//   align-items: center;
//   justify-content: space-between;

//   .el-form-item {
//     &.time-shortcut {
//       background: initial;
//       padding: 0;

//       :deep(.el-form-item__content) {
//         width: auto;

//         .el-button {
//           width: 110px;
//           height: 40px;
//           border-radius: 5px;

//           &.is-active {
//             border: 1px solid #3388FF;
//             color: #3388FF;
//             background-color: #ecf5ff;
//           }
//         }
//       }
//     }
//   }

//   .filter-btn {
//     height: 100%;

//     .btn-group {
//       display: flex;

//       .btn-reset {
//         width: 40px;
//         height: 40px;
//         border-color: #3388ff;
//         color: #3388ff;
//       }

//       .btn-search {
//         width: 84px;
//         height: 40px;
//       }

//       .el-button {
//         &+.el-button {
//           margin-left: -1px !important;
//         }

//         &:first-child {
//           border-top-right-radius: 0 !important;
//           border-bottom-right-radius: 0 !important;
//         }

//         &:last-child {
//           border-top-left-radius: 0 !important;
//           border-bottom-left-radius: 0 !important;
//         }
//       }
//     }
//   }
// }

// .no-margin-top {
//   flex-shrink: 0; // 如果有这个类名，也保证不压缩
// }

// .table-region {
//   flex: 1; // 占用剩余高度
//   display: flex;
//   flex-direction: column;
//   overflow: hidden;

//   .custom-table {
//     flex: 1;
//     display: flex;
//     flex-direction: column;
//     overflow: hidden;

//     .custom-table-header {
//       flex-shrink: 0;
//       padding-right: 4px;
//       text-align: center;
//       scrollbar-gutter: stable;
//     }

//     .custom-table-body {
//       flex: 1;
//       padding-right: 4px;
//       overflow-y: overlay;
//     }
//   }

// }

.table-footer {
  flex-shrink: 0; // 分页区域不压缩，保持固定高度
}
</style>
